import { connect } from 'react-redux';

import { getUser } from '../components/User/userSelectors';
import RootLayout from '../layouts/Root/rootLayout';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  user: getUser(state),
});

const mapDispatchToProps = () => ({
  verifyLoggedUser: () => verifyLoggedUser(),
});

const RootContainer = connect(mapStateToProps, mapDispatchToProps)(RootLayout);

export default RootContainer;
